import {EscortAppPatientEnum} from "../fragments";

export const calculateAge = (dobString) => {
    const dob = new Date(dobString);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();

    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
    }

    return age;
}

export const calculateTotals = (legs) => {
    const result = legs?.reduce(
        (acc, leg) => {
            if (leg?.status === EscortAppPatientEnum.OPEN) {
                acc.openCount += 1;
            }

            if (leg?.status === EscortAppPatientEnum.COMPLETED) {
                acc.completedCount += 1;
            }

            if (
                leg?.status === EscortAppPatientEnum.ASSIGNED ||
                leg?.status === EscortAppPatientEnum.EN_ROUT ||
                leg?.status === EscortAppPatientEnum.ARRIVED
            ) {
                acc.incompleteCount += 1;
            }

            if (leg?.status !== EscortAppPatientEnum.CANCELLED) {
                acc.totalCallRevenue += Number(leg?.callRevenue) || 0;
                acc.totalRevenue += Number(leg?.revenue) || 0;
                acc.distance += Number(leg?.distance) || 0;
                acc.tripsCount += 1;
            }

            return acc;
        },
        {
            tripsCount: 0,
            totalCallRevenue: 0,
            totalRevenue: 0,
            distance: 0,
            openCount: 0,
            incompleteCount: 0,
            completedCount: 0
        }
    );

    return {
        ...result,
        total: (result?.totalCallRevenue || 0) + (result?.totalRevenue || 0)
    }
}